/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { HelmetProvider } from "react-helmet-async";
import routes from "./routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "@fontsource/lexend";
import "./App.css";
import "typeface-belleza";
import "@fontsource/eb-garamond";
import "@fontsource/cinzel";
import { ShoppingCartProvider } from "./context/ShoppingCartContext";
import ShoppingCartModal from "./components/CommonComponents/ShoppingCartModal";
import { fetchGuestUserFlow } from "./store/reducers/authentication/apiThunk";
import { initGA } from "./analytics";

function App() {
  const dispatch = useDispatch();
  const authentication = useSelector((state) => state.authentication);
  const guestUserSessionKey = localStorage.getItem("guestUserSessionKey");

  useEffect(() => {
    const auth_token =
      authentication?.auth?.data?.auth_token ||
      authentication?.auth?.data?.data?.auth_token ||
      authentication?.userData?.data?.auth_token ||
      "";
    if (!auth_token) {
      if (!guestUserSessionKey) {
        guestuserFlow();
      }
    } else {
      localStorage.removeItem("guestUserSessionKey");
    }
  }, [authentication]);

  const guestuserFlow = async () => {
    await dispatch(fetchGuestUserFlow());
  };

  useEffect(() => {
    initGA();
  }, []);

  return (
    <HelmetProvider>
      <ShoppingCartProvider>
        <Suspense fallback={<div>Loading...</div>}>
            <RouterProvider router={routes} />
        </Suspense>
        <ToastContainer />
        <ShoppingCartModal />
      </ShoppingCartProvider>
    </HelmetProvider>
  );
}

export default App;
